<script setup lang="ts">
import { Color } from "~/core/models/Color.enum";
import { capitalizeFirstLetter } from "~/core/utils/string-tools";
import { CampaignOMStatus } from "~/modules/campaign/models/CampaignOMStatus.enum";

const props = defineProps<{
  status: CampaignOMStatus;
}>();

const { t, te } = useI18n();

const badge = computed<{ type: Color; textWhite: boolean }>(() => {
  let type = Color.DANGER;
  let textWhite = false;

  switch (props.status) {
    case CampaignOMStatus.DRAFT:
    case CampaignOMStatus.SCHEDULED:
      type = Color.SECONDARY;
      break;
    case CampaignOMStatus.RUNNING:
      type = Color.PRIMARY;
      textWhite = true;
      break;
    case CampaignOMStatus.COMPLETE:
      type = Color.SUCCESS;
      break;
    case CampaignOMStatus.CANCELLING:
    case CampaignOMStatus.CANCELLED:
    case CampaignOMStatus.COMPLETE_WITH_ERRORS:
    case CampaignOMStatus.INCOMPLETE:
      break;
  }

  return { type, textWhite };
});
</script>

<template>
  <lxc-badge :type="badge.type" :text-white="badge.textWhite">
    {{
      status
        ? te(`campaign.list.column.status.value.${status}`)
          ? t(`campaign.list.column.status.value.${status}`)
          : capitalizeFirstLetter(status)
        : t(`campaign.list.column.status.value.UNKNOWN`)
    }}
  </lxc-badge>
</template>
